// React
import { createContext } from "react"

// Types
import type { IngredientDataType, ProductType } from "../types"

// Types
interface Type extends ProductType {
  approve_by: string
  approve_status: string
}

export const DataContext = createContext<{
  ingredient: IngredientDataType[],
  product: Type
}>({
  ingredient: [],
  product: {
    approve_by: "",
    approve_by_name:"",
    approve_status: "",
    mr_unit_name: "",
    product_barcode: "",
    product_id: 0,
    product_name: "",
    trx_code:"",
    location_id:"",
    employee_id:"",
    qty_build_unit:0,
    component_at_cost:0,
  }
})